<template>
  <div
    class="modal fade"
    :id="`form-modal-${categoryKey}-${sectionIndex}`"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="`form-modal-${categoryKey}-${sectionIndex}-label`"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" :id="`form-modal-${categoryKey}-${sectionIndex}-label`">{{ title }}</h5>
          <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
            <i class="tio-clear tio-lg"></i>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-white" data-dismiss="modal">Annulla</button>
          <button type="button" class="btn btn-primary" @click="submit" :disabled="locked">{{ submitText }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["categoryKey", "sectionIndex", "sectionTitle", "locked"],

  data() {
    return {
      modalType: "add",
    };
  },

  mounted() {
    const self = this;
    $(`#form-modal-${this.categoryKey}-${this.sectionIndex}`).on("show.bs.modal", function () {
      self.modalType = $(this).attr("data-modal-type");
    });
  },

  computed: {
    title() {
      if (this.modalType == "add") return `Aggiungi a ${this.sectionTitle}`;
      return `Modifica ${this.sectionTitle}`;
    },
    submitText() {
      if (this.modalType == "add") return `Aggiungi`;
      return `Modifica`;
    },
  },

  methods: {
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style>
</style>